<template>
  <p class="mb-0" :class="variantClass">
    <slot />
  </p>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    variant: {
      type: String,
      default: "paragraph",
    },
  },
  computed: {
    variantClass(): string {
      const variants: { [key: string]: string } = {
        action: "text-action",
        caption: "text-caption",
        header: "text-header",
        label: "text-label",
        pagesubtitle: "text-pagesubtitle",
        pagetitle: "text-pagetitle",
        paragraph: "text-paragraph",
        subtitle: "text-subtitle",
      };

      return variants[this.variant];
    },
  },
});
</script>
